const Pusher = require("pusher-js");

const shouldEnablePusher = () => {
    // We have to use an early binding param here as the router isn't setup
    return window.location.href.search("print") === -1;
};

export default function pusher() {
    return (store) => {
        if (shouldEnablePusher()) {
            let pusher = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
                cluster: "us3",
            });
            let channel = pusher.subscribe("portal-channel");

            channel.bind("applicant-import-complete", ({ order_id }) => {
                store.dispatch("Screens/importApplicantComplete", order_id);
            });
            channel.bind("applicant-import-error", ({ order_id, error }) => {
                store.dispatch("Screens/importApplicantError", {
                    order_id,
                    error,
                });
            });

            channel.bind(
                "screen-process-complete",
                ({ order_id: orderId, order_status: orderStatus }) => {
                    store.dispatch("Screens/screenProcessComplete", {
                        orderId,
                        orderStatus,
                    });
                }
            );
            channel.bind("screen-process-start", ({ order_id }) => {
                store.dispatch("Screens/screenProcessStart", order_id);
            });
            channel.bind("screen-process-error", ({ order_id, error }) => {
                store.dispatch("Screens/screenProcessError", {
                    order_id,
                    error,
                });
            });

            channel.bind("print-screen-complete", (printData) => {
                store.dispatch("Screens/screenPrintComplete", printData);
            });
            channel.bind("print-screen-error", (errorData) => {
                store.dispatch("Screens/screenPrintError", errorData);
            });
        }
    };
}
